import React from "react";
import LegalPageLayout from "@/components/LegalPageLayout";
import { LEGAL_CONTENT } from "@/data/legalContent";

// Public, unauthenticated route — /terms
const Terms = () => {
  const c = LEGAL_CONTENT.terms;
  return <LegalPageLayout topicKey="terms" title={c.title} body={c.body} />;
};

export default Terms;
